
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/endorsement/[articleId]",
      function () {
        return require("private-next-pages/endorsement/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/endorsement/[articleId]"])
      });
    }
  